module.exports = __webpack_public_path__ + "static/media/OakGroveLogo.7c4bee7d.svg";